var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLunaAiActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Luna_Ai_Active"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Luna_Ai_Active",
    "data-name": "Luna Ai_Active",
    clipPath: "url(#clip-Luna_Ai_Active)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Luna_Ai",
    "data-name": "Luna Ai",
    transform: "translate(5 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2139",
    "data-name": "Group 2139",
    transform: "translate(0 10.19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4699",
    "data-name": "Path 4699",
    d: "M25.3,31.968a1.351,1.351,0,0,1-.441-.049c-.212-.049-.424-.065-.62-.1-.245-.033-.473-.065-.685-.115a20.917,20.917,0,0,1-7.75-4.371,20.53,20.53,0,0,1-5.613-6.925c-.473-1.081-1.028-2.652-.457-3.749a14.4,14.4,0,0,1,2.774-2.865,1.208,1.208,0,0,1,.8-.295,1.181,1.181,0,0,1,.881.377l3.133,3.209a1.238,1.238,0,0,1,0,1.735c-1.175,1.2-1.42,1.834-1.436,2a16.623,16.623,0,0,0,2.937,3.094,20.79,20.79,0,0,0,2.725,2.047.575.575,0,0,0,.277.065c.522,0,1.273-.639,1.991-1.67a1.225,1.225,0,0,1,1.73-.311l3.622,2.6a1.255,1.255,0,0,1,.294,1.735l-.93,1.343c-.179.262-1.55,2.243-3.263,2.243h0Z",
    transform: "translate(-8.819 -12.845)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4700",
    "data-name": "Path 4700",
    d: "M13.568,14.41a.621.621,0,0,1,.424.18L17.125,17.8a.575.575,0,0,1,0,.819c-.62.639-1.714,1.883-1.6,2.57.114.72,2.5,2.914,3.166,3.487a20.4,20.4,0,0,0,2.84,2.128,1.3,1.3,0,0,0,.588.147c1.028,0,2.04-1.244,2.53-1.965a.573.573,0,0,1,.473-.246.541.541,0,0,1,.343.115l3.623,2.6a.581.581,0,0,1,.131.819l-.947,1.343s-1.289,1.948-2.725,1.948a1,1,0,0,1-.31-.033c-.473-.1-.93-.131-1.273-.213C19.328,30.176,12.947,24.79,11.038,20.4c-.359-.835-.93-2.325-.473-3.16a14.96,14.96,0,0,1,2.627-2.669.574.574,0,0,1,.375-.147m0-1.326h0a1.861,1.861,0,0,0-1.224.458c-2.383,2.03-2.807,2.8-2.938,3.062-.718,1.343-.1,3.111.424,4.322,2.073,4.764,8.8,10.429,13.823,11.673a6.007,6.007,0,0,0,.751.131c.2.033.392.049.571.1a3.6,3.6,0,0,0,.571.065,4.1,4.1,0,0,0,2.807-1.343,8.29,8.29,0,0,0,1-1.179l.93-1.326a1.922,1.922,0,0,0-.441-2.636l-3.623-2.6a1.911,1.911,0,0,0-1.11-.36,1.88,1.88,0,0,0-1.55.819,3.5,3.5,0,0,1-1.436,1.392,18.8,18.8,0,0,1-2.595-1.965,22.255,22.255,0,0,1-2.644-2.652,7.735,7.735,0,0,1,1.175-1.473,1.922,1.922,0,0,0,0-2.669l-3.133-3.209a1.927,1.927,0,0,0-1.355-.573h0Z",
    transform: "translate(-9.081 -13.1)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2140",
    "data-name": "Group 2140",
    transform: "translate(12.373 7.284)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_65",
    "data-name": "Subtraction 65",
    d: "M-863.265-797.068a1.32,1.32,0,0,1-1.244-.868l-.409-1.13a2.42,2.42,0,0,0-1.457-1.457l-1.13-.409a1.322,1.322,0,0,1-.868-1.245,1.322,1.322,0,0,1,.868-1.245l1.13-.409a2.422,2.422,0,0,0,1.457-1.457l.409-1.13a1.32,1.32,0,0,1,1.244-.868,1.322,1.322,0,0,1,1.245.868l.409,1.13a2.418,2.418,0,0,0,1.457,1.457l1.13.409a1.322,1.322,0,0,1,.868,1.245,1.322,1.322,0,0,1-.868,1.245l-1.13.409a2.417,2.417,0,0,0-1.457,1.457l-.409,1.13A1.322,1.322,0,0,1-863.265-797.068Zm0-9.578a.673.673,0,0,0-.622.442l-.41,1.129a3.053,3.053,0,0,1-1.849,1.85l-1.13.409a.675.675,0,0,0-.442.623.673.673,0,0,0,.442.622l1.13.409a3.049,3.049,0,0,1,1.849,1.849l.41,1.13a.673.673,0,0,0,.622.442.675.675,0,0,0,.623-.442l.409-1.13a3.052,3.052,0,0,1,1.85-1.849l1.13-.409a.673.673,0,0,0,.442-.622.675.675,0,0,0-.442-.623l-1.13-.409a3.057,3.057,0,0,1-1.85-1.85l-.409-1.129A.675.675,0,0,0-863.265-806.646Z",
    transform: "translate(868.373 807.284)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2141",
    "data-name": "Group 2141",
    transform: "translate(7.985 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_64",
    "data-name": "Subtraction 64",
    d: "M-860.334-792.7a1.366,1.366,0,0,1-1.261-.868v-.066a2.517,2.517,0,0,0-1.457-1.473h-.065a1.32,1.32,0,0,1-.868-1.244,1.366,1.366,0,0,1,.868-1.261h.065a2.52,2.52,0,0,0,1.474-1.457v-.066a1.32,1.32,0,0,1,1.244-.868,1.366,1.366,0,0,1,1.261.868v.066a2.52,2.52,0,0,0,1.457,1.473h.066a1.322,1.322,0,0,1,.868,1.245,1.364,1.364,0,0,1-.868,1.26h-.066a2.521,2.521,0,0,0-1.473,1.457v.066A1.322,1.322,0,0,1-860.334-792.7Zm-2.488-3.029a3.152,3.152,0,0,1,1.867,1.85v.065a.673.673,0,0,0,.622.443.713.713,0,0,0,.639-.443v-.065a3.148,3.148,0,0,1,1.849-1.867h.066a.673.673,0,0,0,.442-.622.71.71,0,0,0-.442-.639h-.066a3.148,3.148,0,0,1-1.867-1.849v-.066a.673.673,0,0,0-.622-.442.71.71,0,0,0-.638.442v.066a3.149,3.149,0,0,1-1.85,1.866h-.066a.673.673,0,0,0-.442.623.71.71,0,0,0,.442.638Z",
    transform: "translate(863.985 800)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2142",
    "data-name": "Group 2142",
    transform: "translate(18.954 1.621)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4705",
    "data-name": "Path 4705",
    d: "M22.3,11.134s-.131-.033-.147-.1a2.075,2.075,0,0,0-1.293-1.343.192.192,0,0,1-.115-.2.184.184,0,0,1,.115-.18,1.8,1.8,0,0,0,1.293-1.343A.157.157,0,0,1,22.3,7.86h0a.143.143,0,0,1,.147.115,1.88,1.88,0,0,0,1.293,1.343.17.17,0,0,1,.115.18.208.208,0,0,1-.115.2,2.3,2.3,0,0,0-1.31,1.343.143.143,0,0,1-.147.1h0Z",
    transform: "translate(-20.675 -7.778)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4706",
    "data-name": "Path 4706",
    d: "M22.321,7.941h0a.1.1,0,0,1,.1.065,1.94,1.94,0,0,0,1.326,1.375.153.153,0,0,1,0,.262,2.251,2.251,0,0,0-1.326,1.375.1.1,0,0,1-.1.065h0a.1.1,0,0,1-.1-.065A2.1,2.1,0,0,0,20.9,9.644a.153.153,0,0,1,0-.262,1.854,1.854,0,0,0,1.326-1.375c0-.049.065-.065.1-.065m0-.115h0a.233.233,0,0,0-.213.147,1.79,1.79,0,0,1-1.261,1.31.219.219,0,0,0-.147.229.263.263,0,0,0,.147.246,2.014,2.014,0,0,1,1.261,1.31.233.233,0,0,0,.213.147h0a.211.211,0,0,0,.213-.147,2.222,2.222,0,0,1,1.277-1.326.265.265,0,0,0,0-.475,1.85,1.85,0,0,1-1.261-1.31.233.233,0,0,0-.213-.147h0Z",
    transform: "translate(-20.7 -7.81)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLunaAiActive);
export default __webpack_public_path__ + "static/media/Luna_Ai_Active.10d3f8b555ecc2135c87eb91bfb8dabf.svg";
export { ForwardRef as ReactComponent };